import React, { ReactElement, useEffect, useState, useRef } from 'react';
import { AppConfiguration } from './@types/AppConfiguration';
import Card from './Card/Card';
import MapCard from './Map/Card/Card';
import MapCanvas from './Map/Canvas/Canvas';
import MapControls from './Map/Controls/Controls';
import MapLegend from './Map/Legend/Legend';
import './WorldMapLeadspace.scss';
import './Map/Map.scss';
import { mapZoomIn, mapZoomOut } from './Map/Canvas/MapEvents';

export interface WorldMapLeadspaceProps {
  /**
   * All the configuration for the map
   */
  configuration: AppConfiguration;
}

const WorldMapLeadspace = ({
  configuration,
}: WorldMapLeadspaceProps): ReactElement => {
  const viewport = useRef(null);

  const [selectedCard, setSelectedCard] = useState<object>({});

  const [selectedLegendTypes, setSelectedLegendTypes] = useState(['']);

  const [isZoomed, setIsZoomed] = useState(false);

  const initiateLegends = () => {
    setSelectedLegendTypes(configuration.legends.map((legend) => legend.type));
  };

  const updateLegendSelection = (value: string) => {
    let newSelectedLegendTypes = [...selectedLegendTypes, value];

    if (selectedLegendTypes.includes(value)) {
      newSelectedLegendTypes = newSelectedLegendTypes.filter(
        (legendType) => legendType !== value,
      );
    }

    setSelectedLegendTypes(newSelectedLegendTypes);
  };

  const onClickMapEntry = (groupIndex: number) => {
    const selectedCard = {
      ...configuration.groups[groupIndex],
    };

    setSelectedCard(selectedCard);
  };

  const onClickCloseMapCardButton = () => {
    setSelectedCard({});
  };

  const updateZoom = (value: boolean) => {
    setIsZoomed(value);
  };

  useEffect(() => {
    initiateLegends();
  }, []);

  return (
    <div className="world-map-leadspace-widget widget-styles">
      <div className="ibm-grid-container">
        <div className="ibm-grid-col-sm-4-4 ibm-grid-col-md-8-2 ibm-grid-col-lg-16-4">
          {Object.keys(selectedCard).length === 0 ? (
            <Card
              title={configuration.card.title}
              description={configuration.card.description}
              legends={configuration.legends}
              selectedLegendTypes={selectedLegendTypes}
              onUpdate={updateLegendSelection}
            />
          ) : (
            <MapCard
              cardInfo={Object.create(selectedCard)}
              legends={configuration.legends}
              selectedLegendTypes={selectedLegendTypes}
              onUpdate={updateLegendSelection}
              onClose={onClickCloseMapCardButton}
            />
          )}
        </div>
        <div className="ibm-grid-col-sm-4-4 ibm-grid-col-md-8-6 ibm-grid-col-lg-16-12">
          <div className="world-map-leadspace-widget__map">
            <MapControls
              isZoomed={isZoomed}
              zoomIn={() => {
                mapZoomIn(viewport);
                updateZoom(true);
              }}
              zoomOut={() => {
                mapZoomOut(viewport);
                setSelectedCard({});
                updateZoom(false);
              }}
            />
            <MapCanvas
              selectedLegendTypes={selectedLegendTypes}
              groups={configuration.groups}
              selectedEntry={selectedCard}
              updateCard={onClickMapEntry}
              updateZoom={updateZoom}
              isZoomed={isZoomed}
              ref={viewport}
            />
            <div className="mobile">
              <MapLegend
                legends={configuration.legends}
                selectedLegendTypes={selectedLegendTypes}
                onUpdate={updateLegendSelection}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorldMapLeadspace;
